import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=4013a174&scoped=true&"
import script from "./CollectionCard.vue?vue&type=script&lang=ts&"
export * from "./CollectionCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=4013a174&prod&scoped=true&lang=css&"
import style1 from "./CollectionCard.vue?vue&type=style&index=1&id=4013a174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013a174",
  null
  
)

export default component.exports